import {html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import deepEqual from 'deep-equal';
import {msg} from '@lit/localize';
import style from '../../../../../scss/space.scss';
import {FormElement} from '../form/formElement';

@customElement('arc-resolution')
export class Resolution extends FormElement {
	static properties = {
		value: {type: Object, hasChanged: (n, o) => !deepEqual(n, o)},
		errors: {type: Array, hasChanged: (n, o) => !deepEqual(n, o)},

		index: {type: Number},
		type: {type: String},
	};

	static styles = [...FormElement.styles, style];

	units = [
		{id: 'px', name: 'px'},
		{id: 'dpi', name: 'dpi'}
	];

	initialValue = {
		type: 'resolution',
		title: [],
		width: {
			unit: 'px',
			value: '',
		},
		height: {
			unit: 'px',
			value: '',
		},
	};

	titleChange(value) {
		this.inputValue.title = value;
		this.dispatchValueChange(this.inputValue);
	}
	inputWidthValue(value) {
		this.inputValue.width.value = value;
		this.dispatchValueChange(this.inputValue);
	}
	selectWidthUnit(value) {
		this.inputValue.width.unit = value;
		this.dispatchValueChange(this.inputValue);
	}
	inputHeightValue(value) {
		this.inputValue.height.value = value;
		this.dispatchValueChange(this.inputValue);
	}
	selectHeightUnit(value) {
		this.inputValue.height.unit = value;
		this.dispatchValueChange(this.inputValue);
	}

	render() {
		return html`
			<div class="space">
				<div class="dimensions">
					<div class="dimension">
						<div class="formContainer">
							<arc-text-input
								class="value"
								id="width"
								class="formInput width"
								.title="${msg('Width')}"
								?disabled="${this.disabled}"
								.multiline=${false}
								.value=${this.inputValue.width.value}
								.errors=${this.errors?.params?.width?.params?.value?.errors || []}
								.required=${true}
								@value-change=${(e) => this.inputWidthValue(e.detail.value)}
							></arc-text-input>
							<arc-select
								class="unit"
								.title=""
								?disabled="${this.disabled}"
								.value=${this.inputValue.width.unit}
								.errors=${this.errors?.params?.width?.params?.unit?.errors || []}
								.options=${this.units}
								.required=${true}
								@value-change=${(e) => this.selectWidthUnit(e.detail.value)}
							>
							</arc-select>
						</div>
					</div>
					<div class="dimension">
						<div class="formContainer">
							<arc-text-input
								class="value"
								id="height"
								class="formInput height"
								.title="${msg('Height')}"
								?disabled="${this.disabled}"
								.multiline=${false}
								.value=${this.inputValue.height.value}
								.errors=${this.errors?.params?.height?.params?.value?.errors || []}
								.required=${true}
								@value-change=${(e) => this.inputHeightValue(e.detail.value)}
							></arc-text-input>
							<arc-select
								class="unit"
								.title=""
								?disabled="${this.disabled}"
								.value=${this.inputValue.height.unit}
								.errors=${this.errors?.params?.height?.params?.unit?.errors || []}
								.options=${this.units}
								.required=${true}
								@value-change=${(e) => this.selectWidthUnit(e.detail.value)}
							>
							</arc-select>
						</div>
					</div>
				</div>
				<arc-multilingual-input
					.title=${msg('Explanation')}
					.value=${this.inputValue.title}
					.errors=${this.errors?.params?.title}
					?disabled="${this.disabled}"
					.required=${false}
					.multiline=${false}
					@value-change=${(e) => this.titleChange(e.detail.value)}>
				</arc-multilingual-input>
			</div>
		`;
	}
}
